import LimitedWidthText from './LimitedWidthText';

export default LimitedWidthText;
